import appConfig from '../../utils/appConfig';
import { isValidUuid } from '../../utils/uuid/uuid';
import onLoad from './onLoad/onLoad';
import reportApiError from './reportApiError/reportApiError';

const apiCall = (
  verb: 'GET' | 'POST' | 'PUT' | 'DELETE',
  path: string,
  data?: URLSearchParams | FormData | object | string,
  signal?: AbortSignal,
  baseUrl?: string,
) => {
  const storedValue = localStorage.getItem('token');
  const isValid = !!storedValue && isValidUuid(storedValue);

  if (storedValue && !isValid) {
    localStorage.removeItem('token');
    window.dispatchEvent(new StorageEvent('token-change'));
  }

  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();

    let url = baseUrl
      ? [baseUrl, path].join('/')
      : [appConfig('VITE_API_SERVER'), isValid ? storedValue : null, path]
          .filter(Boolean)
          .join('/');
    if (data instanceof URLSearchParams) url = [url, data].join('?');

    xhr.open(verb, url, true);
    xhr.timeout = 10_000;

    signal?.addEventListener('abort', () => {
      xhr.abort();
    });

    if (storedValue && isValid) {
      xhr.setRequestHeader('X-Kiosk-Uuid', storedValue);
    }

    if (!data || data instanceof URLSearchParams) {
      xhr.send();
    } else if (data instanceof FormData) {
      xhr.send(data);
    } else if (typeof data === 'string') {
      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
      xhr.send(data);
    } else {
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.send(JSON.stringify(data));
    }

    /* v8 ignore next -- @preserve */
    xhr.onload = () => onLoad(xhr, resolve, reject, { verb, path });
    /* v8 ignore next -- @preserve */
    // Aborts are intentional (e.g. AbortSignal cancellations) — not reported.
    xhr.onabort = () => reject(new Error('Request aborted.'));
    /* v8 ignore next 4 -- @preserve */
    /* istanbul ignore next */
    xhr.ontimeout = () => {
      reportApiError({
        service: 'core',
        method: verb,
        path,
        status: xhr.status,
        failureType: 'timeout',
      });
      // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
      reject({ error: 'Request timeout', status: xhr.status });
    };
    /* v8 ignore next 4 -- @preserve */
    xhr.onerror = () => {
      reportApiError({
        service: 'core',
        method: verb,
        path,
        status: xhr.status,
        failureType: 'network_error',
      });
      // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
      reject({ error: 'Request could not send', status: xhr.status });
    };
  });
};

export default apiCall;
